<p>Sort state: {{ sortState }}</p>
<p>Filter state: {{ filterState }}</p>
<p>PageSize state: {{ pageSizeState }}</p>

<mad-data-table
  [id]="id"
  [filterMode]="'COLUMN_BASED'"
  [persistenceConfig]="persistenceConfig"
  [displayedColumns]="displayedColumns"
  [tableData]="tableData"
  [filterValue]="filterValue"
  [paginationEnabled]="paginationEnabled"
  [pageSizeOptions]="[5, 10, 15]"
  [defaultPageSize]="10"
>
</mad-data-table>
